module.exports = __webpack_public_path__ + "static/media/menu.5a83c251.svg";